import React from 'react';

export default function AppFooter() {
  return (
    <div className="footer">
      <div className="logo">
        <img src="/images/logo-white.png" alt="logo" />
      </div>
      <div>
        <div className="menu">
          <a href="https://member.hoshino-bespokeshoes.jp/privacy" target="_blank">プライバシーポリシー </a>
          |
          <a href="https://member.hoshino-bespokeshoes.jp/terms" target="_blank">ご利用規約</a>
        </div>
        <p className="copyright">© HOSHINO All Rights Reserved.</p>
      </div>
    </div>
  );
}